import { render } from "./CalendarComponent.vue?vue&type=template&id=63acb2a2&scoped=true"
import script from "./CalendarComponent.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&charset=utf-8&lang=js"

import "./CalendarComponent.vue?vue&type=style&index=0&id=63acb2a2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63acb2a2"]])

export default __exports__